// 获取参数 历史模式
const getQueryString = (name) => {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]); return null;
};
// 获取参数 哈希模式
// const getHashQueryString = (name) => {
//     var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
//     var r = window.location.hash.substr(3).match(reg);
//     console.log(r, decodeURIComponent(r[2]), unescape(r[2]));
//     if (r != null) return decodeURIComponent(r[2]); return null;
// };
const deepCopy = (obj) => {
    if (!obj || !(obj instanceof Object) || typeof obj == 'function'){
        return obj;
    }
    const o = obj instanceof Array ? [] : {};
    for (const k in obj) {
        const val = obj[k];
        if (typeof val == 'object') {
            o[k] = deepCopy(val);
        } else {
            o[k] = val;
        }
    }
    return o;
}
// px =》 rem
const setSize = (value) => {
    // @function torem($px){//$rpx为需要转换的字号
    //     @return ($px/75)*1rem;
    // }
    if (value == 'auto') {
      return 'auto';
    } else if (typeof value=='string' && value.indexOf('px')>-1) {
      value = value.split('px')[0];
      return (value/75)+'rem';
      // return value;
    } else if (typeof value=='string' && value.indexOf('%')>-1) {
      return value;
    } else if (Number(value)){
        // return value+'px';
        return (value/75)+'rem';
    } else {
      return value || '';
    }
}
//转换时间 2020-01-12 为 01/12 昨天 几分钟前 几小时前 昨天等
const changeTime = function (showTime) {
    showTime = showTime.replace(/-/g, '/');
    var publishText = '';
    let time = new Date(showTime).getTime() / 1000;
    let currentTime = new Date().getTime() / 1000;
    let timeRange = currentTime - time; //获取时间的秒数
    let minutesRange = Math.floor(timeRange / 60);//获取总分钟数
    let hourRange = Math.floor(minutesRange / 60);//得小时数
    if (minutesRange <= 2) {
      publishText = '刚刚';
    } else if (minutesRange <= 60) {
      publishText = minutesRange + '分钟前';
    } else if (minutesRange <= 720) {
      publishText = hourRange + '小时前';
    }else if (new Date().setHours(0, 0, 0, 0) - 1000 * 24 * 60 * 60 <= new Date(showTime).getTime()){
      publishText = '昨天';
    } else {
      let month = new Date(time * 1000).getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      let day = new Date(time * 1000).getDate();
      day = day < 10 ? '0' + day : day;
      publishText = month + '/' + day;
    }
    return publishText;
  }
module.exports = {
    getQueryString,
    //getHashQueryString,
    deepCopy,
    setSize,
    changeTime
}